import {Component, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {ApprovalPending} from '../../shared/dto/approval-pending';
import {FormControl, FormGroup} from '@angular/forms';
import {DispatchPendingModel} from '../../shared/dto/dispatch-pending.model';
import {ActivatedRoute} from '@angular/router';
import {TokenStorageService} from '../../shared/service/token-storage.service';
import {ApprovalService} from '../../service/approval.service';

@Component({
  selector: 'app-scan-pending-list',
  templateUrl: './scan-pending-list.component.html',
  styleUrls: ['./scan-pending-list.component.scss']
})
export class ScanPendingListComponent implements OnInit {
  public userName: string;
  public type: string;
  scanSearchForm: FormGroup;
  public scanPendingList: DispatchPendingModel[];
  scanPending: DispatchPendingModel = new DispatchPendingModel();
  displayedColumns: string[] = ['RefNo','sidNo', 'nic', 'name', 'cdc' ,'stage', 'createdDate', 'action'];
  dataSource: MatTableDataSource<any>;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  constructor(private route: ActivatedRoute, private approvalService: ApprovalService,
              private tokenStorageService: TokenStorageService) {
    this.route.paramMap.subscribe(params => {
      this.type = params.get('type');
    });
    this.userName=this.tokenStorageService.getUserObjectToken().username;
  }

  ngOnInit() {
    this.scanSearchForm = new FormGroup({
      sidNo: new FormControl(null),
      requestNo: new FormControl(null),
      name: new FormControl(null),
      nic: new FormControl(null),
      cdcNo: new FormControl(null),
    });

    this.onSearch();
  }

  setBase64(code: string): string {
    return btoa(code);
  }

  onSearch() {
    this.scanPending.sidNo = this.scanSearchForm.value.sidNo;
    this.scanPending.appRefNo = (this.scanSearchForm.value.requestNo == "")? null : this.scanSearchForm.value.requestNo;
    this.scanPending.cdcNo = this.scanSearchForm.value.cdcNo;
    this.scanPending.name = this.scanSearchForm.value.name;
    this.scanPending.nic = this.scanSearchForm.value.nic;
    this.scanPending.loginUser = this.userName;
    this.scanPending.type = this.type;

    this.approvalService.searchScanPendingData(this.scanPending).subscribe(
      (result: any ) => {
        this.scanPendingList = result;
        this.dataSource = new MatTableDataSource(this.scanPendingList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onReset() {
    this.scanSearchForm.reset({
      sidNo: null,
      requestNo: null,
      name: null,
      nic: null,
      cdcNo: null,
    });
    this.getAllRequestDetails();
  }

  getAllRequestDetails(){
    this.scanPending.sidNo = this.scanSearchForm.value.sidNo;
    this.scanPending.appRefNo = (this.scanSearchForm.value.requestNo == "")? null : this.scanSearchForm.value.requestNo;
    this.scanPending.cdcNo = this.scanSearchForm.value.cdcNo;
    this.scanPending.name = this.scanSearchForm.value.name;
    this.scanPending.nic = this.scanSearchForm.value.nic;
    this.scanPending.loginUser = this.userName;
    this.scanPending.type = this.type;

    this.approvalService.searchScanPendingData(this.scanPending).subscribe(
      (result: any ) => {
        this.scanPendingList = result;
        this.dataSource = new MatTableDataSource(this.scanPendingList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

}
